import React from "react";
import DashboardLayout from "../components/DashboardLayout";
import { Typography } from "antd";

const { Title, Paragraph } = Typography;

const Dashboard: React.FC = () => {
  return (
    <DashboardLayout>
      <div style={{ padding: "1rem" }}>
        <Title level={3}>Welcome to the Dashboard</Title>
        <Paragraph>
          Use the sidebar to navigate through your projects, chain list, statistics, promotions, and settings.
        </Paragraph>
        <Paragraph>
          This is the main landing page of your dashboard.
        </Paragraph>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;
